import { createContext } from "react";

const SaleContext = createContext(null);

export default SaleContext;
